import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AdminService } from 'src/app/Services/admin.service';

@Component({
  selector: 'app-admin-specialization',
  templateUrl: './admin-specialization.component.html',
  styleUrls: ['./admin-specialization.component.scss']
})
export class AdminSpecializationComponent implements OnInit {

  panelOpenState = false;
  departments:any=[];
  deptForm: FormGroup;
  topics: any;
  isShown = false;
  syllabus:any;

  constructor(
    private adminService: AdminService,
    private fd: FormBuilder,
  ) { }

  ngOnInit(): void {
    // this.adminService.getAdminDepartments().subscribe(data=>this.departments=data['departments']);
    // this.deptForm = this.fd.group({dept:[1]});
    this.adminService.getAdminDepartments().subscribe(data=>{
      this.departments=data['departments'];
      this.onSubmit({dept:1});
    });
    this.deptForm = this.fd.group({dept:[1]});
  }
  
  onSubmit(value){
    this.departments.forEach(element => {
      if(element.id == value.dept){
        this.topics = element.topics;
      }
    });
  }

  showSyllabus(data){
    if(data==this.syllabus){
      this.isShown = !this.isShown;
    }else{
      this.isShown = true;
    }
    this.syllabus=data;
  }

}
